// ui/config/warmQuotes.ts
// 目的：提供「每日/每次登入」可輪替、且三人不重複的溫馨小語。
// 最小變更原則：
// - 不改動既有語句來源（沿用 constants/dailyWarmTips 的語句池）
// - 透過 sessionStorage 建立本次登入/本分頁的 seed

import { DAILY_WARM_TIPS } from "../constants/dailyWarmTips";

export type WarmQuoteUserKey = "kevin" | "ops" | "gm";

export const WARM_QUOTES = DAILY_WARM_TIPS;

const USER_ORDER: WarmQuoteUserKey[] = ["kevin", "ops", "gm"];

function hashToInt(input: string): number {
  let h = 0;
  for (let i = 0; i < input.length; i++) {
    h = (h * 31 + input.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
}

function getTodayKey(): string {
  return new Date().toISOString().slice(0, 10); // YYYY-MM-DD
}

function getSessionSeed(): string {
  try {
    const key = "warmQuoteSeed";
    const existing = sessionStorage.getItem(key);
    if (existing) return existing;

    // 以時間 + 隨機混合，確保每次重新開分頁/重新登入較容易變化
    const seed = `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    sessionStorage.setItem(key, seed);
    return seed;
  } catch {
    // sessionStorage 不可用時（極少數情境），退回固定值
    return "fallback";
  }
}

/**
 * 回傳：本次 session + 今日為基準的「三人不重複」句子
 */
export function getWarmQuotesForSession(): Record<WarmQuoteUserKey, string> {
  const pool = WARM_QUOTES || [];
  if (pool.length === 0) {
    return { kevin: "", ops: "", gm: "" };
  }

  const base = hashToInt(`${getTodayKey()}|${getSessionSeed()}`) % pool.length;

  // 以 base + offset 的方式，保證三人不重複（只要 pool >= 3）
  const pick = (offset: number) => pool[(base + offset) % pool.length];

  return {
    kevin: pick(0),
    ops: pick(1),
    gm: pick(2),
  };
}

/**
 * 便利方法：單人取句（仍維持三人不重複的規則）
 */
export function getWarmQuoteForSession(userKey: WarmQuoteUserKey): string {
  const map = getWarmQuotesForSession();
  return map[userKey] ?? "";
}
